import { TextField } from "@mui/material";
import { useTranslation } from "react-i18next";
import { TransferDraftErrors } from "../../../../entities";
import {
  useTransferDraft,
  useTransferDraftDispatch,
} from "../../../../providers/transferDraft";
import { TransferDraftActionType } from "../../../../reducers/transferDraft";
import { fixedFieldSx } from "./fixedFieldSx";

type EmailTextFieldProps = {
  disabled?: boolean;
};

export default function EmailTextField({ disabled }: EmailTextFieldProps) {
  const transferDraft = useTransferDraft();
  const transferDraftDispatch = useTransferDraftDispatch();
  const { t } = useTranslation();

  return (
    <TextField
      sx={fixedFieldSx}
      disabled={disabled}
      error={transferDraft.errors.has(TransferDraftErrors.invalidSenderEmail)}
      helperText={
        transferDraft.errors.has(TransferDraftErrors.invalidSenderEmail)
          ? t(`Invalid email address`)
          : undefined
      }
      value={transferDraft.anon.email}
      required
      fullWidth
      type="email"
      label={t(`Your email address`)}
      InputProps={{
        disableUnderline: true,
      }}
      // TODO this is not triggered when auto-filling
      onChange={(newValue) => {
        transferDraftDispatch({
          type: TransferDraftActionType.senderEmailUpdate,
          updatedEmail: newValue.target.value,
        });
      }}
    />
  );
}
